import { theme } from "./theme/theme";

export function logVersion(): void {
  console.log(
    `%c                                                
                 FE version ${import.meta.env.PACKAGE_VERSION}               
                                                `,
    `background: ${theme.palette.primary.main}; color: #FFF; padding: 3px; font-weight: bold; margin: -3px;`,
  );
}
